import { registerPlugin, Capacitor } from '@capacitor/core';

interface SignaturePlugin {
  getSignatureHash(): Promise<{ hash: string }>;
}

const SignaturePlugin = registerPlugin<SignaturePlugin>('SignaturePlugin');

/**
 * Reads the APK signing certificate hash fresh from PackageManager.
 * Must be called fresh on every token request — never cache the result
 * between calls, as the nonce it pairs with is single-use.
 *
 * Returns an empty string on non-Android platforms —
 * APK validation is only applicable on Android.
 */
export const getSignatureHash = async (): Promise<string> => {
  if (Capacitor.getPlatform() !== 'android') {
    return '';
  }
  const { hash } = await SignaturePlugin.getSignatureHash();
  return hash;
};
